import { render, staticRenderFns } from "./CRUDAreas.vue?vue&type=template&id=54d013f6&"
import script from "./CRUDAreas.vue?vue&type=script&lang=js&"
export * from "./CRUDAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports